"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OctagonFreightServicesLLC = void 0;
exports.OctagonFreightServicesLLC = {
    id: 'octagonFreightServicesLLC',
    companyName: 'Octagon Freight Services L.L.C.',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'octagonFreightServicesLLC',
    },
    isInternal: false,
    isActive: true,
    countries: ['AE'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT2N0YWdvbkZyZWlnaHRTZXJ2aWNlc0xMQy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hZ2VudHMvZGF0YS9PY3RhZ29uRnJlaWdodFNlcnZpY2VzTExDLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEseUJBQXlCLEdBQVU7SUFDNUMsRUFBRSxFQUFFLDJCQUEyQjtJQUMvQixXQUFXLEVBQUUsaUNBQWlDO0lBQzlDLGNBQWMsRUFBRSxDQUFDLEtBQUssRUFBRSxLQUFLLENBQUM7SUFDOUIsV0FBVyxFQUFFO1FBQ1QsV0FBVyxFQUFFLElBQUk7UUFDakIsS0FBSyxFQUFFLDJCQUEyQjtLQUNyQztJQUNELFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsU0FBUyxFQUFFLENBQUMsSUFBSSxDQUFDO0NBQ3BCLENBQUEifQ==